module.exports = __webpack_public_path__ + "img/tcLangBtn.67415c37.png";